import { render, staticRenderFns } from "./CourtWintersville.vue?vue&type=template&id=c2b349c8&scoped=true&"
import script from "./CourtWintersville.vue?vue&type=script&lang=js&"
export * from "./CourtWintersville.vue?vue&type=script&lang=js&"
import style0 from "./CourtWintersville.vue?vue&type=style&index=0&id=c2b349c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2b349c8",
  null
  
)

export default component.exports